import '@babel/polyfill';
import Vue from 'vue';
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import App from './App.vue';
import './registerServiceWorker';
import store from './store';
import i18n from './plugins/i18n';

import router from './router';
import './assets/roboto/roboto.css';

Vue.config.productionTip = false;

if (process.env.NODE_ENV !== `development`) {
  Sentry.init({
    Vue,
    dsn: `https://065175b7173641ff80aa74b2df49320f@o279728.ingest.sentry.io/1502842`,
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2
  });
}

new Vue({
  store: store.store,
  router,
  i18n,
  render: h => h(App),
}).$mount(`#app`);
